declare global {
  interface Window {
    onYouTubeIframeAPIReady: () => void;
    YT: any;
  }
}

export class CardTemoignage {
  private videoWrappers: HTMLElement[] = [];

  constructor() {
    this._init();
  }

  private _init(): void {
    document.addEventListener('DOMContentLoaded', () => {
      this.videoWrappers = Array.from(document.querySelectorAll('[data-card-temoignage]'));
      if (this.videoWrappers.length > 0) {
        this._loadYouTubeAPI();
      }
    });
  }

  private _loadYouTubeAPI(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(tag, firstScript);
    }

    window.onYouTubeIframeAPIReady = this._onYouTubeAPIReady.bind(this);
  }

  private _onYouTubeAPIReady(): void {
    this.videoWrappers.forEach((wrapper) => {
      const videoId = wrapper.querySelector<HTMLElement>('[data-youtube-id]')?.dataset.youtubeId;
      const iframe = wrapper.querySelector<HTMLIFrameElement>('iframe');

      if (!videoId || !iframe || !iframe.id) return;

      new window.YT.Player(iframe.id, {
        events: {
          onReady: (event: any) => {
            const player = event.target;

            wrapper.addEventListener('mouseenter', () => {
              player.mute();
              player.playVideo();
            });

            wrapper.addEventListener('mouseleave', () => {
              player.pauseVideo();
            });
          }
        }
      });
    });
  }
}

export const cardTemoignage = new CardTemoignage();
